define('../app/fukit/view/block/confirm.destroy.modal.view',['require','exports','module','underscore','uikit/uikit','../../helpers/extend.util','marionette','handlebars'],function(require, exports, module) {
  //prettier-ignore
  var _          = require('underscore'),
      UIKit      = require('uikit/uikit'),
      ExtendUtil = require('../../helpers/extend.util'),
      Mn         = require('marionette'),
      Handlebars = require('handlebars');

  var BaseDestroyModalTextFormatterBehavior = Mn.Behavior.extend({
    onFirstBeforeRender: function() {
      this.listenTo(this.view, 'change:actionText change:entityTypeText change:entityText', function() {
        this.view.text = this.getTextFormat();
      });
      this.view.text = this.getTextFormat();
    },

    getTextFormat: function() {
      return '';
    },
  });

  var HeaderTextFormatterBehavior = BaseDestroyModalTextFormatterBehavior.extend({
    getTextFormat: function() {
      var view = this.view;
      return (
        view.getOption('actionText') +
        ' ' +
        (view.getOption('entityTypeText') ? view.getOption('entityTypeText') : 'Item')
      );
    },
  });

  var ContentTextFormatterBehavior = BaseDestroyModalTextFormatterBehavior.extend({
    getTextFormat: function() {
      var view = this.view;
      return new Handlebars.SafeString(
        'Are you sure you want to ' +
          (view.getOption('actionText') || '').toLowerCase() +
          ' ' +
          (view.getOption('entityText')
            ? '<i>' + Handlebars.escapeExpression(view.getOption('entityText')) + '</i>'
            : 'this item') +
          '?'
      );
    },
  });

  var ConfirmDestroyModalView = UIKit.Modal2.extend({
    options: _.extend({}, UIKit.Modal2.prototype.options, {
      actionText: 'Delete',
      entityTypeText: null,
      entityText: null,
      basic: true,
      size: 'small',
      closeable: true,
    }),

    internalViewOptions: UIKit.Modal2.extendInternalViewOptions({
      headerView: ExtendUtil.extendOptionValueWithDefaults('header', function() {
        var bindings = _.pick(this.bindings, 'actionText', 'entityTypeText', 'entityText');
        return {
          text: '',
          actionText: this.getOption('actionText'),
          entityTypeText: this.getOption('entityTypeText'),
          entityText: this.getOption('entityText'),
          model: this.model,
          bindings: bindings,
          behaviors: {
            HeaderTextFormatterBehavior: {
              behaviorClass: HeaderTextFormatterBehavior,
            },
          },
        };
      }),

      contentView: ExtendUtil.extendOptionValueWithDefaults('content', function() {
        var bindings = _.pick(this.bindings, 'actionText', 'entityTypeText', 'entityText');
        return {
          type: UIKit.Modal2.SimpleContentView,
          icon: 'trash outline',
          text: '',
          actionText: this.getOption('actionText'),
          entityTypeText: this.getOption('entityTypeText'),
          entityText: this.getOption('entityText'),
          model: this.model,
          bindings: bindings,
          behaviors: {
            ContentTextFormatterBehavior: {
              behaviorClass: ContentTextFormatterBehavior,
            },
          },
        };
      }),

      actionsView: ExtendUtil.extendOptionValueWithDefaults('actions', function() {
        return {
          components: [
            {
              type: UIKit.Modal2.DenyButtonView,
              text: this.getOption('denyButtonText') || 'Cancel',
              inverted: true,
              color: 'basic',
              name: 'denyButton',
            },
            {
              type: UIKit.Modal2.ConfirmButtonView,
              color: 'negative',
              icon: 'trash',
              text: this.getOption('confirmButtonText') || 'Delete',
              name: 'confirmButton',
            },
          ],
        };
      }),
    }),
  });

  module.exports = ConfirmDestroyModalView;
});

